import { Observable } from 'rxjs';
import { RouterStateSnapshot } from '@angular/router';

interface ComponentWithPreventNavigation {
    preventNavigation: (nextState: RouterStateSnapshot) => Observable<boolean>;
}

export function preventNavigationGuard(
    component: ComponentWithPreventNavigation,
    currentRoute?,
    currentState?,
    nextState?: RouterStateSnapshot
): Observable<boolean> | true {
    if (component.preventNavigation) {
        return component.preventNavigation(nextState);
    }

    return true;
}
